var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 42,
    width: 10,
    height: 16,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 42,
    width: 10,
    height: 16,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 10,
    height: 32,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26,
    width: 10,
    height: 32,
    rx: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,15.184l-7.649,7.649a5.015,5.015,0,1,0,1.414,1.414L19.816,16.6A7.017,7.017,0,0,1,18.4,15.184Z",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 5,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4,15.184l-7.649,7.649a4.966,4.966,0,0,0-5.506,0L29.6,15.184A7.017,7.017,0,0,1,28.184,16.6l7.649,7.649a5,5,0,1,0,8.334,0L51.816,16.6A7.017,7.017,0,0,1,50.4,15.184Z",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 11,
    r: 5,
    "data-color": "color-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.50f92136273f703895c856130168b4b0.svg";
export { ForwardRef as ReactComponent };